<template>
  <section
    class="configure-company-document"
    id="drag-template-background"
    v-loading="documentDataLoading"
  >
    <div class="inner-navbar" v-if="documentData">
      <el-row type="flex" align="middle" justify="center">
        <el-col :span="7">
          <el-button round icon="el-icon-back" @click="goToDocuments()"
            >Back to Documents</el-button
          >
        </el-col>
        <el-col :span="10">
          <h2 class="font-weight-normal blue-2">{{ documentData.title }}</h2>
        </el-col>
        <el-col :span="6">
          <div class="float-right">
            <el-button class="btn" type="success" @click="saveDocumentData()">
              <i class="el-icon-s-claim"></i> SAVE &amp; UPDATE
            </el-button>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="input-options">
      <el-row type="flex" justify="center">
        <el-col :span="17">
          <div v-if="documentData">
            <el-card class="download-card">
              <h3 class="font-weight-normal blue">
                <i class="el-icon-document"></i> Document
              </h3>
              <el-button
                v-if="hasSampleDocument"
                @click="onDownload"
                type="primary"
                round
              >
                <i class="el-icon-download pr-1"></i> Sample Download
              </el-button>
              <el-button
                v-if="getDocumentUrl"
                @click="onDownloadUserDocument"
                type="primary"
                round
              >
                <i class="el-icon-download pr-1"></i> Download
              </el-button>
            </el-card>
          </div>
          <div v-if="getDocumentUrl">
            <img
              v-if="isImage"
              :src="getDocumentUrl"
              width="500"
              height="400"
            />

            <pdf
              v-if="isPdf"
              :src="getDocumentUrl"
              width="500"
              height="400"
            ></pdf>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="form-fields-set">
            <el-row>
              <h3 class="font-weight-normal text-center blue mb-05">
                Document Details
              </h3>
              <el-form v-model="userDocumentFormData">
                <el-form-item label="Document Number">
                  <el-input
                    v-model="userDocumentFormData.document_number"
                  ></el-input>
                </el-form-item>

                <el-form-item label="Issuing Authority">
                  <el-input
                    v-model="userDocumentFormData.issuing_authority"
                  ></el-input>
                </el-form-item>

                <el-form-item label="Document Valid From">
                  <el-date-picker
                    type="date"
                    v-model="userDocumentFormData.valid_from"
                  ></el-date-picker>
                </el-form-item>

                <el-form-item label="Document Expires">
                  <el-date-picker
                    type="date"
                    v-model="userDocumentFormData.expires_at"
                  ></el-date-picker>
                </el-form-item>

                <el-divider class="mb-05"></el-divider>
                <el-form-item label="E-signature Required ?" class="mb-0">
                  <el-radio-group
                    v-model="userDocumentFormData.e_signature_value"
                    @change="updateEsignValue"
                  >
                    <el-radio :label="'YES'">Yes</el-radio>
                    <el-radio :label="'NO'">No</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>

              <div class="signature-box mb-0">
                <el-card shadow="never" class="mt-1 bg-light">
                  <div class="text-center">
                    <el-button
                      class="btn-link p-0"
                      type="text"
                      @click="onUploadDocument"
                      >Upload Document</el-button
                    >
                  </div>
                </el-card>
              </div>

              <div
                class="signature-box mb-0"
                v-if="
                  documentSentStatus &&
                  userDocumentFormData.e_signature_required
                "
              >
                <el-card shadow="never" class="mt-1 bg-light">
                  <div
                    class="float-right"
                    v-if="userDocumentFormData.e_signature_status"
                  >
                    <div class="success">
                      <i class="el-icon-finished"></i> Completed
                    </div>
                  </div>
                  <div
                    class="float-right"
                    v-if="!userDocumentFormData.e_signature_status"
                  >
                    <div class="error">Pending</div>
                  </div>
                  <h4 class="font-weight-normal">E-Signature</h4>
                  <el-divider class="mt-05 mb-05"></el-divider>
                  <div
                    class="text-center"
                    v-if="userDocumentFormData.e_signature_status"
                  >
                    <el-button
                      class="btn-link p-0"
                      type="text"
                      @click="onESignView"
                      >View Signature</el-button
                    >
                  </div>
                </el-card>
              </div>
            </el-row>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-dialog :visible.sync="showSavedSignatureData" title="eSignature">
      <div v-loading="esignLoading">
        <el-row>
          <el-col :span="24" v-if="esignData">
            <ESignatureDataView :esignData="esignData"></ESignatureDataView>
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <UploadRequestedDocument
      v-if="uploadRequestedDocumentDialog"
      :documentData="requestedDocumentData"
      v-on:close="closeUploadedDocumentDialog"
    ></UploadRequestedDocument>
  </section>
</template>

<script>
import appConfig from "@/config/app";
import { mapGetters } from "vuex";
import ESignatureDataView from "@/components/signature/ESignatureDataView";

import UploadRequestedDocument from "@/components/employeeDocuments/UploadRequestedDocument";
import pdf from "vue-pdf";

export default {
  components: {
    ESignatureDataView,
    UploadRequestedDocument,
    pdf,
  },

  created() {},
  data() {
    return {
      elements: [],
      width: 0,
      height: 0,
      x: 0,
      y: 0,
      addItemDataDialogVisible: false,
      selectedItemIndex: null,
      selectedItem: {},
      refreshForm: false,
      selectedSignatureItem: {},
      selectedSignatureItemIndex: -1,
      captureSignatureDialog: false,
      hasBackground: false,
      documentId: null,
      configurableDocumentId: null,
      documentDataLoading: false,
      documentFormData: null,
      documentName: "",
      loading: false,
      backgroundImage: "",
      previewVisible: false,
      activatedItem: null,
      activatedItemIndex: -1,

      currentFormBuilderWidth: null,
      storedFormBuilderWidth: null,
      checkExistingData: false,
      backgroundImages: [],
      loadingElements: false,
      selectedTemplateFields: [],
      templatesUsed: [],
      showErrorElementDialog: false,
      errorElements: [],
      fieldErrorMessage: "",
      workflowDataId: "",
      userId: "",

      userDocumentFormData: {
        valid_from: "",
        expires_at: "",
        e_signature_required: "",
        e_signature_value: "",
        e_signature_status: false,
        download_object_key: "",
        document_number: "",
        issuing_authority: "",
        download_url: "",
        document_meta_data: {},
        company_document_data: {},
      },
      documentSentStatus: false,

      employeeDocumentId: "",
      documentData: {},
      workflowStepId: "",
      showSavedSignatureData: false,
      esignLoading: false,
      esignData: {},

      requestedDocumentData: {},
      uploadRequestedDocumentDialog: false,
    };
  },
  computed: {
    ...mapGetters("company", ["getCompanyProfileData"]),
    ...mapGetters("employeeData", ["getESignData"]),
    ...mapGetters("workflowData", [
      "getWorkflowDataAssetDataAddStatus",
      "getUserWorkflowData",
    ]),
    ...mapGetters("companyDocuments", [
      "getCompanyDocumentDataById",
      "getDownloadUrl",
      "getDownloadError",
    ]),
    ...mapGetters("employeeDocuments", [
      "getEmployeeDocumentDataById",
      "getEmployeeDocumentUpdateStatus",
    ]),

    getLogoUrl() {
      return appConfig.S3_BUCKET_URL + "/" + this.getCompanyProfileData.logo;
    },
    getDocumentUrl() {
      return this.userDocumentFormData.download_url;
    },
    isPdf() {
      return (
        this.userDocumentFormData.document_meta_data &&
        this.userDocumentFormData.document_meta_data.file_type ==
          "application/pdf"
      );
    },
    isImage() {
      return (
        this.userDocumentFormData.document_meta_data &&
        this.userDocumentFormData.document_meta_data.file_type.indexOf(
          "image"
        ) > -1
      );
    },

    hasSampleDocument() {
      return this.userDocumentFormData.company_document_data &&
        this.userDocumentFormData.company_document_data.path
        ? true
        : false;
    },
  },
  async mounted() {
    this.fetchCompanyDetails();
    this.setData();
    this.documentDataLoading = true;

    if (this.employeeDocumentId) {
      await this.fetchEmployeDocumentData();
      this.setEmployeeDocumentData();
    }

    this.documentDataLoading = false;
    await this.fetchWorkflowData();
  },
  methods: {
    setData() {
      this.employeeDocumentId = this.$route.query.employee_document_id;
      this.configurableDocumentId = this.$route.params.configurable_document_id;
      this.documentId = this.$route.params.document_id;
      this.workflowStepId = this.$route.query.workflow_step_id;
    },

    async fetchWorkflowData() {
      this.workflowDataId = this.$route.params.workflow_data_id;

      if (this.workflowDataId) {
        this.userId =
          this.getUserWorkflowData && this.getUserWorkflowData.user_id
            ? this.getUserWorkflowData.user_id
            : null;

        let steps = this.getUserWorkflowData.workflow_steps_data || [];

        this.documentSentStatus = steps.find(
          (x) => x.step_id == this.workflowStepId && x.sent_status
        )
          ? true
          : false;
      }

      if (this.userId && this.templatesUsed.length) {
        await this.fetchUserTemplateData();
      }
    },

    setEmployeeDocumentData() {
      if (this.employeeDocumentId && this.getEmployeeDocumentDataById) {
        this.userDocumentFormData.e_signature_required = this.getEmployeeDocumentDataById.e_signature_required;
        this.userDocumentFormData._id = this.employeeDocumentId;
        this.userDocumentFormData.e_signature_status = this.getEmployeeDocumentDataById.e_signature_status;
        this.userDocumentFormData.expires_at = this.getEmployeeDocumentDataById.expires_at;
        this.userDocumentFormData.valid_from = this.getEmployeeDocumentDataById.valid_from;
        this.userDocumentFormData.title = this.getEmployeeDocumentDataById.title;
        this.userDocumentFormData.issuing_authority = this.getEmployeeDocumentDataById.issuing_authority;
        this.userDocumentFormData.document_number = this.getEmployeeDocumentDataById.document_number;
        this.userDocumentFormData.document_meta_data = this.getEmployeeDocumentDataById.document_meta_data;
        this.userDocumentFormData.company_document_data = this.getEmployeeDocumentDataById.company_document_data;

        this.userDocumentFormData.download_url = this
          .getEmployeeDocumentDataById.download_url
          ? this.getEmployeeDocumentDataById.download_url
          : "";
        this.userDocumentFormData.e_signature_value = this
          .getEmployeeDocumentDataById.e_signature_required
          ? "YES"
          : "NO";

        console.log(this.getEmployeeDocumentDataById);
      }
    },

    async fetchCompanyDetails() {
      await this.$store.dispatch("company/getCompany");
    },

    async fetchDocumentData() {
      await this.$store.dispatch("companyDocuments/fetchCompanyDocumentById", {
        id: this.documentId,
      });

      this.documentData = this.getCompanyDocumentDataById;

      this.documentDataLoading = false;
    },

    async onDownload() {
      await this.$store.dispatch("companyDocuments/downloadCompanyDocument", {
        id: this.documentId,
      });
      if (this.getDownloadUrl) {
        window.open(this.getDownloadUrl, "_blank");
      } else {
        this.$notify.error({
          title: "Error",
          message: this.getDownloadError,
        });
      }
    },

    onDownloadUserDocument() {
      window.open(this.getDocumentUrl, "_blank");
    },

    async fetchEmployeDocumentData() {
      await this.$store.dispatch(
        "employeeDocuments/fetchEmployeeDocumentById",
        {
          id: this.employeeDocumentId,
        }
      );
    },

    goToDocuments() {
      this.$router.go(-1);
    },
    saveDocumentData() {
      try {
        if (this.employeeDocumentId) {
          this.updateEmployeeDocument();
        } else {
          this.addEmployeeDocument();
        }
      } catch (err) {
        console.log(err);
      }
    },

    async addEmployeeDocument() {
      try {
        let companyDocumentData = {
          company_document_id: this.documentId,
          document_type: "STATIC",
          valid_from: this.userDocumentFormData.valid_from,
          expires_at: this.userDocumentFormData.expires_at,
          e_signature_required:
            this.userDocumentFormData.e_signature_value == "YES" ? true : false,
        };
        let params = {
          workflow_data_id: this.workflowDataId,
          asset: "COMPANY_DOCUMENTS",
          workflow_step_id: this.workflowStepId,
          company_document_data: companyDocumentData,
        };
        await this.$store.dispatch(
          "workflowData/addAssetDataToWorkFlowData",
          params
        );
        if (this.getWorkflowDataAssetDataAddStatus) {
          this.$notify.success({
            title: "Success",
            message: "Document Data Saved Successfully",
          });
          this.goToDocuments();
        } else {
          this.$notify.error({
            title: "Error",
            message: "Erorr at updating document",
          });
        }
      } catch (err) {
        this.$notify.error({
          title: "Error",
          message: "Erorr at updating document",
        });
      }
    },
    async updateEmployeeDocument() {
      try {
        let params = {
          id: this.employeeDocumentId,
          valid_from: this.userDocumentFormData.valid_from,
          expires_at: this.userDocumentFormData.expires_at,
          e_signature_required:
            this.userDocumentFormData.e_signature_value == "YES" ? true : false,
        };

        await this.$store.dispatch(
          "employeeDocuments/updateEmployeeDocument",
          params
        );

        if (this.getEmployeeDocumentUpdateStatus) {
          this.$notify.success({
            title: "Success",
            message: "Document Data Saved Successfully",
          });
          this.goToDocuments();
        } else {
          this.$notify.error({
            title: "Error",
            message: "Erorr at updating document",
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async onESignView() {
      try {
        this.showSavedSignatureData = true;
        this.esignLoading = true;
        let params = {
          id: this.getEmployeeDocumentDataById.e_signature,
        };
        await this.$store.dispatch("employeeData/fetchESignData", params);
        this.esignLoading = false;
        this.esignData = this.getESignData;
      } catch (err) {
        console.log(err);
      }
    },

    async onUploadDocument() {
      this.requestedDocumentData = { ...{}, ...this.userDocumentFormData };

      this.uploadRequestedDocumentDialog = true;
    },
    async closeUploadedDocumentDialog(data) {
      this.uploadRequestedDocumentDialog = false;
      if (data) {
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      }
    },

    updateEsignValue(value) {
      this.userDocumentFormData.e_signature_required = value === "YES";
    },
  },
  beforeDestroy() {
    this.$store.commit("company/setCompanyProfileData",null,{root:true})
    this.$store.commit("employeeDocuments/setEmployeeDocumentUpdateStatus",null,{root:true})
    this.$store.commit("employeeDocuments/setEmployeeDocumentDataById",null,{root:true})
    this.$store.commit("companyDocuments/setCompanyDocumentDataById",null,{root:true})
    this.$store.commit("companyDocuments/setDownloadUrl",null,{root:true})
    this.$store.commit("companyDocuments/setDownloadError",null,{root:true})
    this.$store.commit("employeeData/setESignData",null,{root:true})
    this.$store.commit("configurableDocuments/setConfigurableDocumentDataById",null,{root:true})
    this.$store.commit("workflowData/setWorkflowDataAssetDataAddStatus",null,{root:true})
    this.$store.commit("workflowData/setUserWorkflowData",null,{root:true})
  }
};
</script>